import React from 'react';
import PropTypes from 'prop-types';
import { ListGroupItemHeading } from 'reactstrap';
import { ListGroupItem } from '@cordata/buffet';
import { format, differenceInYears } from 'date-fns';
import { formatPhone } from '~/utils';

const PatientSummary = ({ patient, action, onClick }) => {
  return (
    <ListGroupItem action={action} onClick={onClick}>
      <ListGroupItemHeading>
        {patient.summaryPatient.lastName}, {patient.summaryPatient.firstName}{' '}
        {patient.summaryPatient.birthDate && (
          <span className="text-tertiary">
            {format(patient.summaryPatient.birthDate, 'MM/DD/YYYY')}
          </span>
        )}
      </ListGroupItemHeading>

      <div className="text-tertiary">
        <div className="d-flex flex-wrap m-0">
          <span className="mr-3">
            Age:{' '}
            {patient.summaryPatient.birthDate
              ? `${differenceInYears(
                  new Date(),
                  patient.summaryPatient.birthDate,
                )} y.o.`
              : 'Unknown'}
          </span>{' '}
          <span className="mr-3">Gender: {patient.gender.genderLabel}</span>
          <span className="mr-3">
            Race:
            {patient.race.map(r => r.raceLabel).join(', ')}
          </span>
        </div>
        <div>
          {patient.primaryPhone && (
            <p className="m-0">
              {formatPhone(patient.primaryPhone.phoneNumber)}
            </p>
          )}
        </div>

        <div>
          {patient.addresses && (
            <>
              {patient.addresses.map(a => (
                <p className="m-0">
                  {a.addr1} {a.addr2 && `${a.addr2} `}
                  {a.city}, {a.provinceIso} {a.postCode}
                </p>
              ))}
            </>
          )}
        </div>
      </div>

      {patient.summaryPatient.note && (
        <>
          <span className="text-danger">Priority Note:</span>{' '}
          {patient.summaryPatient.note}
        </>
      )}
    </ListGroupItem>
  );
};

PatientSummary.propTypes = {
  patient: PropTypes.shape({}).isRequired,
  action: PropTypes.bool,
  onClick: PropTypes.func,
};

PatientSummary.defaultProps = {
  action: false,
  onClick: () => {},
};

export default PatientSummary;
